import type {ReactElement} from 'react';
import {useState} from 'react';
import type {SOURCE} from '@Libraries/stock-graphic-library';
import {isStockItemPredominantlyWhite} from '@Libraries/pmw-stock-media-library';
import type {GridItemProps} from '../grid-item';
import type {GridMediaItemStorage, GridMediaItemTag} from '../grid-media-item';
import {GridMediaItem} from '../grid-media-item';
import {GridItemTag} from '../grid-item-tag/grid-item-tag';

export interface GridClipartItemStorage extends GridMediaItemStorage {
  thumbSrc: string;
  source: SOURCE;
  data: Record<string, any>;
}

export interface GridClipartItemBackEndData {
  id: string;
  hidden: boolean;
  tu: string;
  u: string;

  [key: string]: any;
}

interface GridClipartItemProps extends GridItemProps {
  thumbSrc: string;
  paddedThumb?: boolean;
  tag?: GridMediaItemTag;
}

export function GridClipartItem({...props}: GridClipartItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasGrayBackground, setHasGrayBackground] = useState(false);

  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      hasGrayBackground={hasGrayBackground}
      thumb={
        <div className="_full-width _full-height _position-relative">
          <img
            onLoad={(): void => {
              setIsImageLoaded(true);
              void isStockItemPredominantlyWhite(props.thumbSrc).then(setHasGrayBackground);
            }}
            src={props.thumbSrc}
            className="radius-12 _full-width _full-height"
            alt={window.i18next.t('pmwjs_image')}
            draggable="false"
            loading="lazy"
          />
          <GridItemTag tag={props.tag} />
        </div>
      }
    />
  );
}
